import i18n from '@dms/i18n';

import {RentalVehicle} from '../../core/types/RentalVehicle';
import {Field} from './primitives/Field';

export function RentalNoteTextarea() {
  return (
    <Field<RentalVehicle, 'textarea'>
      type="textarea"
      name="rentalProperties.note"
      label={i18n.t('entity.rental.labels.note')}
    />
  );
}
